<template>
  <div class="new-notification-event modal-content box">
    <p class="title is-5">Add Event</p>
    <section class="container">
      <form
        class="new-notification-event__form"
        @submit.prevent="addEventHandler"
      >
        <b-field label="Event Title">
          <b-input
            v-model="newEvent.title"
            type="text"
            placeholder="Enter event title"
            required
            @input="updateSlug"
          >
          </b-input>
        </b-field>
        <b-field label="Event Description">
          <b-input
            v-model="newEvent.description"
            type="textarea"
            placeholder="Enter event title"
            required
          >
          </b-input>
        </b-field>
        <div class="new-notification-event__form__switch">
          <b-switch v-model="newEvent.hasMultiple" name="hasMultiple">
            <b>Has multiple triggers?</b>
          </b-switch>
        </div>
        <b-field label="Event Slug">
          <b-input
            v-model="newEvent.slug"
            type="text"
            placeholder="Edit Event slug"
            required
            @input="slugEdited = true"
          >
          </b-input>
        </b-field>
        <b-button class="is-fullwidth" native-type="submit" type="is-primary">
          Add
        </b-button>
      </form>
    </section>
  </div>
</template>

<script>
import { getSlugged } from '../../../utils/string';

const NewNotificationEventModal = {
  data() {
    return {
      newEvent: {
        title: '',
        description: '',
        hasMultiple: false,
        slug: ''
      },
      slugEdited: false
    };
  },
  methods: {
    async addEventHandler() {
      this.$emit('input', this.newEvent);
      this.$emit('close');
    },
    updateSlug(event) {
      if (!this.slugEdited) this.newEvent.slug = getSlugged(event);
    }
  }
};

export default NewNotificationEventModal;

export function getNewNotificationEvent(parent) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: NewNotificationEventModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      onCancel: reject
    });
  });
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.new-notification-event {
  width: auto;
  &__form {
    @include tablet {
      min-width: 20rem;
    }

    &__switch {
      display: flex;
      flex-direction: column;
      align-items: stretch;

      &:not(:last-child) {
        margin-bottom: 0.75rem;
      }
    }
  }
}
</style>
